import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Showtime } from '../models';
import { CompactShowtimePillComponent } from './compact-showtime-pill.component';

export interface CinemaShowtimeGroup {
  county: string;
  cinema: string;
  chain: string;
  city: string;
  items: Showtime[];
}

@Component({
  selector: 'app-cinema-showtime-group',
  standalone: true,
  imports: [CommonModule, CompactShowtimePillComponent],
  template: `
    <article class="cinema-times" *ngIf="group">
      <div class="cinema-line">
        <div>
          <h2>{{ group.cinema }}</h2>
          <p>{{ group.city }} · {{ group.chain }} · {{ group.county }}</p>
        </div>
        <span>{{ group.items.length }}</span>
      </div>

      <div class="time-list">
        <app-compact-showtime-pill *ngFor="let showtime of group.items" [showtime]="showtime" />
      </div>
    </article>
  `,
  styles: [
    `
      .cinema-times {
        border: 1px solid var(--line);
        border-radius: 15px;
        padding: 11px 12px;
        background: var(--surface-row);
        box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18);
      }

      .cinema-line {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 10px;
        margin-bottom: 8px;
      }

      h2 {
        margin: 0 0 3px;
        color: var(--text);
        font-size: 15px;
        line-height: 1.16;
        font-weight: 950;
        overflow-wrap: anywhere;
      }

      p {
        margin: 0;
        color: var(--muted);
        font-size: 12px;
        line-height: 1.25;
        font-weight: 750;
      }

      .cinema-line > span {
        min-width: 30px;
        min-height: 24px;
        border-radius: 999px;
        padding: 4px 8px;
        display: grid;
        place-items: center;
        color: var(--cyan);
        background: var(--control-bg);
        font-size: 11px;
        font-weight: 950;
      }

      .time-list {
        display: flex;
        flex-wrap: wrap;
        gap: 7px;
      }

      @media (max-width: 640px) {
        .cinema-times {
          padding: 10px;
          border-radius: 14px;
        }

        h2 {
          font-size: 14px;
        }

        p {
          font-size: 11px;
        }

        .time-list {
          gap: 6px;
        }
      }
    `,
  ],
})
export class CinemaShowtimeGroupComponent {
  @Input({ required: true }) group!: CinemaShowtimeGroup;
}
